import { FC } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter/components/AdvancedFilterRow';
import { InlineFilter } from 'shared/components/InlineFilter';
import { RangeInput } from 'shared/components/RangeInput';
import { useDebouncedCallback, useFilterChangeCallback } from 'shared/hooks';
import { selectFromMkadKmFilter } from 'shared/selectors/advancedFilters/fromMkadKm';

export const FromMkadContainer: FC = () => {
  const { label, valueMax, valueMin, min, max } = useSelector(selectFromMkadKmFilter);

  const onChange = useFilterChangeCallback();

  const handleMinChange = useDebouncedCallback((value: number | null) => {
    onChange({ action: 'setFromMKADMin', arguments: [value] });
  });

  const handleMaxChange = useDebouncedCallback((value: number | null) => {
    onChange({ action: 'setFromMKADMax', arguments: [value] });
  });

  return (
    <AdvancedFilterRow label={label}>
      <InlineFilter width={100} postfix="км">
        <RangeInput
          min={min}
          max={max}
          valueMin={valueMin}
          valueMax={valueMax}
          onChangeMin={handleMinChange}
          onChangeMax={handleMaxChange}
        />
      </InlineFilter>
    </AdvancedFilterRow>
  );
};
